
import axios from '../config/axios';

export const url = '/api/contactochambaindexam5yh'


export const createcontactochambaindexam5yh = ({
  token,
	dnikqfh8,
	nombre39835,
	correo0znnpi,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && dnikqfh8 && correo0znnpi ) {

    axios.post(`${url}//create/basic/6910e6f7e307249250074275`, {
		dnikqfh8,
		nombre39835,
		correo0znnpi,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!dnikqfh8) {
		reject({
			status: 'error',
			info: 'DNI no esta definido',
		});
	}  else if (!correo0znnpi) {
		reject({
			status: 'error',
			info: 'Correo no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

